import React from "react";
import {
  Row,
  Col,
  Input,
  Button,
  message,
  Modal,
  Form,
  Card,
  InputNumber,
  Spin,
} from "antd";
import { AiOutlineClose } from "react-icons/ai";

import axios from "axios";
import API_URL from "../../constants/API_URL";
import moment from "moment";
import "./custompayment.css";
import { transform } from "lodash";
import Swal from "sweetalert2";

function PaymentPopUp(props) {
  const {
    form: { getFieldDecorator },
  } = props;
  const PAYMENT_SCREEN = props.language.INJAZ_POS_POS_SCREEN.PAYMENT_SCREEN;
  const [customer_col_points, setCustomer_col_points] = React.useState(0);
  const [order, setOrder] = React.useState({});
  const [totalNet, setTotalNet] = React.useState(0);
  const [collectionBtnLoader, setCollectionBtnLoader] = React.useState(false);
  const [colModalVisible, setColModalVisible] = React.useState(false);
  const [actualAmt, setActualAmt] = React.useState(0);
  const [extraCharge, setExtraCharge] = React.useState(0);
  const [orderPaymentsList, setOrderPaymentsList] = React.useState([]);
  const [paymethods, setPaymethods] = React.useState([]);
  const [discountAmt, setDiscountAmt] = React.useState(0);
  const [amountPaycheck, setAmountPaycheck] = React.useState(0);
  const [amountPay, setAmountPay] = React.useState(0);
  const [isColPointUsed, setIsColPointUsed] = React.useState(false);
  const [coll_points, setColl_points] = React.useState(0);
  const [coupon, setCoupon] = React.useState(null);
  const [couponNo, setCouponNo] = React.useState(null);
  const [isCashGivenModal, setIsCashGivenModal] = React.useState(false);
  const [cashGiven, setCashGiven] = React.useState(0);
  const [payCash, setPayCash] = React.useState(0);
  const [selectAmountbtn, setSelectAmountbtn] = React.useState(null);
  const [customModal, setCustomModal] = React.useState(false);
  const [visible, setVisible] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [couponBtnLoader, setCouponBtnLoader] = React.useState(false);
  const [orderCompleteState, setOrderCompleteState] = React.useState(false);
  const [activebtn, setActivebtn] = React.useState(null);

  React.useEffect(() => {
    getCustomer();
    getOrderDetails();
  }, []);
  React.useEffect(() => {
    setExtraChargeFunc();
  }, [order]);
  React.useEffect(() => {
    console.log(totalNet);
  }, [totalNet]);
  React.useEffect(() => {
    setDiscount();
  }, [props.isDiscountP, props.disAmt, props.disPrctg, actualAmt]);

  const setDiscount = () => {
    if (props.isDiscount) {
      if (props.isDiscountP) {
        let percntgDis = (props.disPrctg / 100) * actualAmt;
        let temp = Number(actualAmt) - Number(percntgDis);
        setTotalNet(temp);
        setDiscountAmt(percntgDis);
      } else {
        let temp = Number(actualAmt) - Number(props.disAmt);
        setTotalNet(temp);
        setDiscountAmt(props.disAmt);
      }
    }
  };
  const getCustomer = () => {
    let accessToken = localStorage.getItem("accessToken");
    let lang = localStorage.getItem("lang");
    let tokenType = localStorage.getItem("tokenType");
    axios({
      method: "GET",
      url: API_URL + "customerByID",
      params: {
        id: props.posStorage.customer,
        lang: lang,
      },
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
    }).then((res) => {
      if (res.data.success) {
        if (res.data.object.name != "Walk In Customer") {
          setCustomer_col_points(res.data.object.collectPoints);
        } else {
          setCustomer_col_points(0);
        }
      }
    });
  };
  const getOrderPaymentsList = async (orderId) => {
    await axios({
      url: API_URL + "paymentLinesByOrder",
      method: "GET",
      params: {
        orderId: orderId,
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    }).then(async (res) => {
      await setOrderPaymentsList(res.data);
    });
  };
  const getOrderDetails = () => {
    payMethodsGet();
    let headers = {
      Authorization:
        localStorage.getItem("tokenType") +
        " " +
        localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    };
    let authOptions = {
      method: "GET",
      url: API_URL + "saleOrderByID",
      params: {
        id: props.posStorage.orderId,
        lang: localStorage.getItem("lang"),
      },
      headers,
    };
    axios(authOptions)
      .then((res) => {
        getOrderPaymentsList(res.data.object.id);
        setTotalNet(res.data.object.totalNet);
        setActualAmt(res.data.object.totalNet);
        setOrder(res.data.object);
      })
      .catch((err) => {});
  };
  const setExtraChargeFunc = () => {
    let extraChargeTemp = 0;
    if (order.chargeType == "P") {
      if (order.minCharge * order.noOfGuest - totalNet > 0) {
        extraChargeTemp = order.minCharge * order.noOfGuest - totalNet;
        let tax = extraChargeTemp * (order.taxRate / 100);
        extraChargeTemp = parseFloat(extraChargeTemp) + parseFloat(tax);
        extraChargeTemp = parseFloat(extraChargeTemp);
        let amountPaycheckTemp =
          parseFloat(extraChargeTemp) +
          parseFloat(totalNet) -
          parseFloat(order.paidAmt);
        setExtraCharge(extraChargeTemp);
        setAmountPaycheck(amountPaycheckTemp);
      }
    } else if (order.chargeType == "T") {
      if (order.minCharge - totalNet > 0) {
        extraChargeTemp = order.minCharge - totalNet;
        let tax = extraChargeTemp * (order.taxRate / 100);
        extraChargeTemp = parseFloat(extraChargeTemp) + parseFloat(tax);
        extraChargeTemp = parseFloat(extraChargeTemp);
        let amountPaycheckTemp =
          parseFloat(extraChargeTemp) +
          parseFloat(totalNet) -
          parseFloat(order.paidAmt);
        setExtraCharge(extraChargeTemp);
        setAmountPaycheck(amountPaycheckTemp);
      }
    }
  };
  const payMethodsGet = () => {
    let headers = {
      Authorization:
        localStorage.getItem("tokenType") +
        " " +
        localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    };
    let authOptions = {
      method: "GET",
      url: API_URL + "ActiveBranchPayMethodsList",
      params: {
        branchId: JSON.parse(localStorage.getItem("userData")).branchId,
        lang: localStorage.getItem("lang"),
      },
      headers,
    };
    axios(authOptions).then((res) => {
      setPaymethods(res.data);
    });
  };
  const changePayMethod = (e) => {
    console.log(e);
    setActivebtn(e);
    if (e === order.payMethod) {
      message.error("This Payment Method is already selected");
    } else {
      let headers = {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      };
      let authOptions = {
        url: API_URL + "updateSaleOrder",
        method: "POST",
        data: {
          lang: localStorage.getItem("lang"),
          id: order.id,
          customer: order.customer,
          payMethod: e,
          flrTable: order.flrTable,
          orderType: order.orderType,
          cashier: JSON.parse(localStorage.getItem("userData")).userId,
          noOfGuest: order.noOfGuest,
        },
        headers,
      };
      axios(authOptions)
        .then((res) => {
          if (res.data.success) {
            message.success(res.data.message);
            payMethodsGet();
            getOrder();
          }
        })
        .catch((err) => {});
    }
  };
  const getOrder = () => {
    let headers = {
      Authorization:
        localStorage.getItem("tokenType") +
        " " +
        localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    };
    let authOptions = {
      method: "GET",
      url: API_URL + "saleOrderByID",
      params: {
        id: props.posStorage.orderId,
        lang: localStorage.getItem("lang"),
      },
      headers,
    };
    axios(authOptions)
      .then((res) => {
        setOrder(res.data.object);
      })
      .catch((err) => {});
  };
  const colModalOkHandler = (e) => {
    e.preventDefault();
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    props.form.validateFields((err, values) => {
      if (!err) {
        setCollectionBtnLoader(false);
        if (JSON.parse(localStorage.getItem("branch_data")).isColPointEnable) {
          let discountTemp =
            (values.collectPoints /
              JSON.parse(localStorage.getItem("branch_data")).pointValue) *
            JSON.parse(localStorage.getItem("branch_data")).pointValueAmt;
          let orderTemp = { ...order };
          let actualAmtTemp = orderTemp.totalNet;
          let totalNet = actualAmtTemp - discountTemp;
          setCollectionBtnLoader(false);
          setColModalVisible(false);
          setTotalNet(totalNet);
          setDiscountAmt(discountTemp);
          setAmountPaycheck(totalNet);
          setIsColPointUsed(true);
          setColl_points(values.collectPoints);
          setCoupon(null);
          setCouponNo(null);
        } else {
          message.error("Collection Points Are Not Enable For This Branch");
        }
      }
    });
  };

  const calculatorCollectionPoints = (e) => {
    let cashGiven = coll_points;
    if (e != "b" && e != "c" && e != "e" && e != ".") {
      cashGiven = cashGiven + e.toString();
      props.form.setFieldsValue({
        collectPoints: parseFloat(cashGiven),
      });
      setColl_points(cashGiven);
    } else if (
      e == "b" &&
      props.form.getFieldValue("collectPoints") != 0 &&
      props.form.getFieldValue("collectPoints") != ""
    ) {
      cashGiven = cashGiven.toString();
      if (cashGiven.length == 1) {
        cashGiven = 0;
        props.form.setFieldsValue({
          collectPoints: parseFloat(cashGiven),
        });
        setColl_points(cashGiven);
      } else {
        cashGiven = cashGiven.substring(0, cashGiven.length - 1);
        props.form.setFieldsValue({
          collectPoints: parseFloat(cashGiven),
        });
        setColl_points(cashGiven);
      }
    } else if (e == "c") {
      cashGiven = 0;
      props.form.setFieldsValue({
        collectPoints: parseFloat(cashGiven),
      });
      setColl_points(cashGiven);
    } else if (e == ".") {
      if (cashGiven == 0) {
        cashGiven = "0.";
        props.form.setFieldsValue({
          collectPoints: parseFloat(cashGiven),
        });
        setColl_points(cashGiven);
      } else {
        props.form.setFieldsValue({
          collectPoints: parseFloat(cashGiven),
        });
        setColl_points(cashGiven);
      }
    }
  };
  const openCashGivenModal = () => {
    setIsCashGivenModal(true);
    document.getElementById("root").classList.add("blurClass");
  };
  React.useEffect(() => {
    if (orderCompleteState) {
      paySaleOrder();
      setOrderCompleteState(false);
    }
  }, [amountPaycheck]);

  // let deluser = () => {
  //     console.log(this.props.tablename, 'this.props.tablename this.props.tablename')
  // }
  console.log("props.tablenamezxc", props.tablename);
  // "[Othman] On Click Pay"
  const zatcaIntegrationShareInvoice = async (orderId) => {
    axios({
      url: API_URL + `zatca-integration/share-invoice?orderId=${orderId}`,
      method: "POST",
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (res.data.success) {
          Swal.fire({
            title: "Success!",
            text: "Invoice is successfuly shared with ZATCA!",
            icon: "success",
          });
        }
      })
      .catch((err) => {});
  };
  const calculatorFunction = async (e) => {
    props.deletuser(props.tablename);
    let amountPayTemp = amountPay;
    console.log(e, "value from event");

    if (e != "b" && e != "c" && e != "e" && e != ".") {
      if (e == 0 || amountPayTemp[amountPayTemp.length - 1]) {
        amountPayTemp = amountPayTemp + e.toString();
        setAmountPay(amountPayTemp);
        setAmountPaycheck(amountPayTemp);
      } else {
        amountPayTemp = amountPayTemp + e.toString();
        setAmountPay(parseFloat(amountPayTemp));
        setAmountPaycheck(parseFloat(amountPayTemp));
      }
    } else if (e == "b" && amountPay != 0 && amountPay != "") {
      amountPayTemp = amountPayTemp.toString();
      if (amountPayTemp.length == 1) {
        amountPayTemp = 0;
        setAmountPay(amountPayTemp);
        setAmountPaycheck(amountPayTemp);
      } else {
        amountPayTemp = amountPayTemp.substring(0, amountPayTemp.length - 1);
        setAmountPay(parseFloat(amountPayTemp));
        setAmountPaycheck(parseFloat(amountPayTemp));
      }
    } else if (e == "c") {
      amountPayTemp = 0;
      setAmountPay(parseFloat(amountPayTemp));
      setAmountPaycheck(parseFloat(amountPayTemp));
    } else if (e == ".") {
      if (amountPay == 0) {
        amountPayTemp = "0.";
        setAmountPay(amountPayTemp);
        setAmountPaycheck(amountPayTemp);
      } else {
        amountPayTemp = amountPayTemp + ".";
        setAmountPay(amountPayTemp);
        setAmountPaycheck(amountPayTemp);
      }
    } else if (e == "e") {
      if (paymethods.filter((item) => item.id === order.payMethod).length > 0) {
        if (
          paymethods
            .filter((item) => item.id === order.payMethod)[0]
            .name.toLowerCase() === "cash"
        ) {
          if (
            amountPaycheck > 0 &&
            (
              parseFloat(extraCharge) +
              parseFloat(totalNet) -
              order.paidAmt
            ).toFixed(2) > parseFloat(amountPaycheck)
          ) {
            openCashGivenModal();
            console.warn("working openCashGivenModal");
          } else {
            if (selectAmountbtn == 0 || selectAmountbtn == 1) {
              let amountPayTemp = (
                parseFloat(extraCharge) +
                parseFloat(totalNet) -
                order.paidAmt
              ).toFixed(2);
              let payCashTemp = amountPaycheck;
              let cashGivenTemp = amountPaycheck;
              let amountPaycheckTemp = amountPayTemp;
              await setPayCash(payCashTemp);
              await setCashGiven(cashGivenTemp);
              await setAmountPay(amountPayTemp);
              await setAmountPaycheck(amountPaycheckTemp);
              paySaleOrder();
              await setLoading(true);
              await setCustomModal(false);
              // deluser()
              console.warn("else ka if");
            } else {
              let amountPayTemp = (
                parseFloat(extraCharge) +
                parseFloat(totalNet) -
                order.paidAmt
              ).toFixed(2);
              let payCashTemp = amountPaycheck;
              let cashGivenTemp = amountPaycheck - amountPayTemp;
              await setAmountPay(amountPayTemp);
              await setPayCash(payCashTemp);
              await setCashGiven(cashGivenTemp);
              await setOrderCompleteState(true);
              await setAmountPaycheck(amountPayTemp);
              setCustomModal(false);
              console.warn("else ka else");
            }
          }
        } else {
          setLoading(true);
          paySaleOrder();
          setCustomModal(false);
          console.warn("else");
        }
      } else {
        setLoading(false);
        message.error("please select payment method");
      }
    }
  };
  const paySaleOrder = () => {
    setLoading(true);

    if (JSON.parse(localStorage.getItem("userData")).isCashMgmt) {
      if (order.isMinCharge) {
        if (order.chargeType == "P") {
          let amountPaycheck = order.minCharge * order.noOfGuest;
          if (totalNet >= amountPaycheck) {
            callPaySaleOrderAPI(totalNet);
          } else {
            callPaySaleOrderAPI(amountPaycheck);
          }
        } else if (order.chargeType == "T") {
          let amountPaycheck = order.minCharge;
          if (totalNet >= amountPaycheck) {
            callPaySaleOrderAPI(totalNet);
          } else {
            callPaySaleOrderAPI(amountPaycheck);
          }
        }
      } else {
        callPaySaleOrderAPI(totalNet);
      }
    } else {
      setLoading(false);
      message.error("Only Cash Manager Can Pay");
    }
    return false;
  };
  // [Othman] verify paySaleOrder
  const callPaySaleOrderAPI = (totalNet) => {
    if (
      amountPaycheck >= 0 &&
      (
        parseFloat(extraCharge) +
        parseFloat(actualAmt) -
        (order.paidAmt + discountAmt)
      ).toFixed(2) >= parseFloat(amountPaycheck)
    ) {
      let data = {
        saleOrderId: order.id,
        lang: localStorage.getItem("lang"),
        cashier: JSON.parse(localStorage.getItem("userData")).userId,
        totalNet: totalNet,
        coupon: coupon,
        discountAmt: discountAmt,
        actualAmt: actualAmt,
        isDiscount: props.isDiscount,
        couponNo: couponNo,
        payMethod: order.payMethod,
        payCash: payCash,
        paymentAmt: amountPaycheck,
        isColPointUsed: isColPointUsed,
        collectPoints: parseInt(coll_points),
      };
      if (props.deliveryPerson) {
        data.deliveryPerson = props.deliveryPerson;
      }
      let a = {
        url: API_URL + "paySaleOrder",
        method: "POST",
        data: data,
        headers: {
          Authorization:
            localStorage.getItem("tokenType") +
            " " +
            localStorage.getItem("accessToken"),
          "Content-Type": "application/json",
        },
      };

      axios(a).then(async (res) => {
        if (res.data.success) {
          setLoading(false);
          await getOrderDetails();
          setAmountPay(0);
          setCashGiven(0);
          message.success(res.data.message);
          await getOrderPaymentsList(order.id);
          await zatcaIntegrationShareInvoice(order.id);
          if (res.data.object.status.toUpperCase() == "P") {
            let cashPaidAmount = 0;
            if (
              paymethods.filter((item) => item.name.toLowerCase() == "cash")
                .length > 0
            ) {
              if (
                orderPaymentsList.filter(
                  (i) =>
                    i.payMethod ===
                    paymethods.filter(
                      (item) => item.name.toLowerCase() == "cash",
                    )[0].id,
                ).length > 0
              ) {
                cashPaidAmount = orderPaymentsList.filter(
                  (i) =>
                    i.payMethod ===
                    paymethods.filter(
                      (item) => item.name.toLowerCase() == "cash",
                    )[0].id,
                )[0].paymentAmt;
              }
            }
            props.paymentok();
            //await props.printCall((parseFloat(order.paidAmt) + parseFloat(amountPaycheck)), cashPaidAmount)
          } else {
            await props.saleOrderByIDFunction();
          }
        } else if (!res.data.success) {
          setLoading(false);
          message.error(res.data.message);
        }
      });
    } else {
      setLoading(false);
      message.error("Pay amount is more than the Order Amount");
    }
  };
  const cashGivenModalHandler = () => {
    if (cashGiven >= amountPaycheck) {
      paySaleOrder();
      setLoading(true);
      setIsCashGivenModal(false);
      document.getElementById("root").classList.remove("blurClass");
    } else {
      message.error("cash given by customer should not less than pay amount");
    }
  };
  const calculatorFunctioncashGiven = (e) => {
    let cashGivenTemp = cashGiven;
    if (e != "b" && e != "c" && e != "e" && e != ".") {
      cashGivenTemp = cashGivenTemp + e.toString();
      setCashGiven(parseFloat(cashGivenTemp));
    } else if (e == "b" && cashGiven != 0 && cashGiven != "") {
      cashGivenTemp = cashGivenTemp.toString();
      if (cashGiven.length == 1) {
        cashGivenTemp = 0;
        setCashGiven(parseFloat(cashGivenTemp));
      } else {
        cashGivenTemp = cashGivenTemp.substring(0, cashGivenTemp.length - 1);
        setCashGiven(parseFloat(cashGivenTemp));
      }
    } else if (e == "c") {
      cashGivenTemp = 0;
      setCashGiven(parseFloat(cashGivenTemp));
    } else if (e == ".") {
      if (cashGivenTemp == 0) {
        cashGivenTemp = "0.";
        setCashGiven(parseFloat(cashGivenTemp));
      } else {
        cashGivenTemp = cashGivenTemp + ".";
        setCashGiven(parseFloat(cashGivenTemp));
      }
    } else if (e == "e") {
      if (paymethods.filter((item) => item.id === order.payMethod).length > 0) {
        if (
          paymethods
            .filter((item) => item.id === order.payMethod)[0]
            .name.toLowerCase() === "cash"
        ) {
          console.log("openCashGivenModal");
          openCashGivenModal();
        } else {
          console.log("paySaleOrder othman");
          this.paySaleOrder();
        }
      } else {
        message.error("please select payment method");
      }
    }
  };
  const onOkayHandler = (e) => {
    e.preventDefault();
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    props.form.validateFields((err, values) => {
      if (!err) {
        setCouponBtnLoader(true);
        var authOptions = {
          method: "GET",
          url: API_URL + "couponByCouponNo",
          params: {
            couponNo: values.couponNo,
            clientId: localStorage.getItem("clientId"),
            lang: localStorage.getItem("lang"),
          },
          headers: {
            Authorization: tokenType + " " + accessToken,
            "Content-Type": "application/json",
          },
        };
        axios(authOptions).then((res) => {
          if (res.data.success) {
            if (res.data.object) {
              var fromDate = res.data.object.fromDate;
              var toDate = res.data.object.toDate;
              var from = Date.parse(fromDate);
              var to = Date.parse(toDate);
              var check = Date.parse(moment(new Date()).format("YYYY-MM-DD"));
              if (
                check >= from &&
                check <= to &&
                res.data.object.status == "A" &&
                res.data.object.noOfTimeUse > res.data.object.used
              ) {
                if (localStorage.getItem("coupon")) {
                  let singleCoupon = {
                    orderId: order.id,
                    coupon: res.data.object,
                  };
                  let coupons = JSON.parse(localStorage.getItem("coupon"));
                  if (
                    coupons.findIndex((item) => item.orderId == order.id) == -1
                  ) {
                    coupons.push(singleCoupon);
                    localStorage.setItem("coupon", JSON.stringify(coupons));
                  } else {
                    let index = coupons.findIndex(
                      (item) => item.orderId == order.id,
                    );
                    coupons[index] = singleCoupon;
                    localStorage.setItem("coupon", JSON.stringify(coupons));
                  }
                } else {
                  let couponDetails = [
                    {
                      orderId: order.id,
                      coupon: res.data.object,
                    },
                  ];
                  localStorage.setItem("coupon", JSON.stringify(couponDetails));
                }
                let orderTemp = { ...order };
                if (res.data.object.discountType == "P") {
                  let actualAmtTemp = orderTemp.totalNet;
                  let discountAmtTemp =
                    (orderTemp.totalNet * res.data.object.discountPtg) / 100;
                  let totalNetTemp = actualAmtTemp - discountAmtTemp;
                  setCoupon(res.data.object.id);
                  setVisible(false);
                  setTotalNet(totalNetTemp);
                  setAmountPaycheck(totalNetTemp);
                  setColl_points(0);
                  setActualAmt(actualAmtTemp);
                  setIsColPointUsed(false);
                  setDiscountAmt(discountAmtTemp);
                  setCouponNo(values.couponNo);
                  setCouponBtnLoader(false);
                } else if (res.data.object.discountType == "A") {
                  let totalNetTemp =
                    orderTemp.totalNet - res.data.object.discountAmt;
                  let discountAmtTemp = res.data.object.discountAmt;
                  let actualAmtTemp = orderTemp.totalNet;
                  if (actualAmtTemp >= discountAmt) {
                    setCoupon(res.data.object.id);
                    setVisible(false);
                    setTotalNet(totalNetTemp);
                    setAmountPaycheck(totalNetTemp);
                    setColl_points(0);
                    setActualAmt(actualAmtTemp);
                    setIsColPointUsed(false);
                    setDiscountAmt(discountAmtTemp);
                    setCouponNo(values.couponNo);
                    setCouponBtnLoader(false);
                  } else {
                    message.error(
                      "Your Order Amount Is less than Required Amount",
                    );
                    setCouponBtnLoader(false);
                  }
                }
              } else {
                setCouponBtnLoader(false);
                message.error(
                  "You Have Entered A Expired Token Or Token Is alredy used",
                );
              }
            } else {
              setCouponBtnLoader(false);
              message.error("Invalid Coupon!");
            }
          } else {
            setCouponBtnLoader(false);
            message.error(res.data.message);
          }
        });
      }
    });
  };

  return (
    <React.Fragment>
      <div className="paymentwrapper">
        <button
          className="cancelbtn"
          onClick={() => {
            props.cancelPopUp();
          }}
        >
          <AiOutlineClose />
        </button>
        <div className="walkininvoice">
          <div className="wrap">
            <p className="hedi">
              {PAYMENT_SCREEN.WALKIN_CUSTOMER || "Walkin Customer"}
            </p>
            <p>
              {PAYMENT_SCREEN.EXPECTED || "Expected"}: {actualAmt.toFixed(2)}
            </p>
            <p>
              {PAYMENT_SCREEN.REMAIN}:
              {(
                parseFloat(extraCharge) +
                parseFloat(totalNet) -
                order.paidAmt
              ).toFixed(2)}
            </p>
          </div>

          <div className="invoice">
            <p className="hedi">
              {PAYMENT_SCREEN.INVOICE_AMOUNT || "Invoice Amount"}
            </p>
            <p className="amount">
              {PAYMENT_SCREEN.SAR || "SAR"} {actualAmt.toFixed(2)}
            </p>
          </div>
        </div>
        <div className="paycols">
          <div className="coppoi">
            <p className="point" onClick={() => setVisible(true)}>
              {PAYMENT_SCREEN.USE_COUPON || "Use Coupon"}
            </p>
            <p className="point" onClick={() => setColModalVisible(true)}>
              {PAYMENT_SCREEN.USE_POINTS || "Use Points"}
            </p>
            <p style={{ background: "none", color: "black" }}>
              {PAYMENT_SCREEN.POINTS_EQUALS || "Points ="} {customer_col_points}
            </p>
          </div>

          <div className="paymentmethods">
            <div className="btnsec">
              {paymethods.length > 0 &&
                paymethods.map((item) => (
                  <button
                    className={activebtn == item.id ? "activebtn" : null}
                    onClick={() => changePayMethod(item.id)}
                    value={item.id}
                    key={item.id}
                  >
                    {item.name}
                  </button>
                ))}
            </div>
            <p className="hedi">{PAYMENT_SCREEN.QUICK_PAY || "Quick Pay"}</p>
            <div className="btn">
              {paymethods.filter((item) => item.id == order.payMethod).length >
                0 &&
                paymethods
                  .filter((item) => item.id == order.payMethod)[0]
                  .name.toLowerCase() == "cash" && (
                  <>
                    <Button
                      className={`selectAmount ${selectAmountbtn == 10 &&
                        "selected"}`}
                      onClick={() => {
                        setAmountPaycheck(10);
                        setSelectAmountbtn(10);
                      }}
                    >
                      10
                    </Button>
                    <Button
                      onClick={() => {
                        setAmountPaycheck(50);
                        setSelectAmountbtn(50);
                      }}
                      className={`selectAmount ${selectAmountbtn == 50 &&
                        "selected"}`}
                    >
                      50
                    </Button>
                    <Button
                      onClick={() => {
                        setAmountPaycheck(100);
                        setSelectAmountbtn(100);
                      }}
                      className={`selectAmount ${selectAmountbtn == 100 &&
                        "selected"}`}
                    >
                      100
                    </Button>
                    <Button
                      onClick={() => {
                        setAmountPaycheck(500);
                        setSelectAmountbtn(500);
                      }}
                      className={`selectAmount ${selectAmountbtn == 500 &&
                        "selected"}`}
                    >
                      500
                    </Button>
                  </>
                )}

              <Button
                className={`selectAmount ${selectAmountbtn == 1 && "selected"}`}
                onClick={() => {
                  setAmountPaycheck(
                    (
                      parseFloat(extraCharge) +
                      parseFloat(totalNet) -
                      order.paidAmt
                    ).toFixed(2),
                  );
                  setSelectAmountbtn(1);
                }}
              >
                {(
                  parseFloat(extraCharge) +
                  parseFloat(totalNet) -
                  order.paidAmt
                ).toFixed(2)}
              </Button>
              <Button
                className={`selectAmount ${selectAmountbtn == 0 && "selected"}`}
                onClick={() => {
                  setCustomModal(true);
                  setSelectAmountbtn(0);
                }}
              >
                {PAYMENT_SCREEN.CUSTOM || "Custom"}
              </Button>
            </div>

            <div className="btnsection">
              {order.payMethod &&
                (selectAmountbtn == 10 ||
                  selectAmountbtn == 50 ||
                  selectAmountbtn == 100 ||
                  selectAmountbtn == 1 ||
                  selectAmountbtn == 500) && (
                  <button
                    className={loading ? "loaddingPay" : ""}
                    loading={loading}
                    onClick={() => calculatorFunction("e")}
                  >
                    {loading
                      ? PAYMENT_SCREEN.LOADING || "loading.."
                      : PAYMENT_SCREEN.PAY || "Pay"}
                  </button>
                )}
            </div>
          </div>
        </div>
      </div>
      <Row
        gutter={24}
        style={{ opacity: loading ? 0.3 : 1.0, display: "none" }}
      >
        <Col span={7}>
          <Button className="discBtn" onClick={() => setVisible(true)}>
            {PAYMENT_SCREEN.COUPON || "COUPON"}
          </Button>
          <Button className="discBtn" onClick={() => setColModalVisible(true)}>
            {PAYMENT_SCREEN.POINTS || "POINTS"}
          </Button>
          {orderPaymentsList.length > 0 &&
            paymethods.length > 0 &&
            orderPaymentsList.map((item) => (
              <Row gutter={24} key={item.id}>
                <Col span={16}>
                  <p style={{ fontSize: "14px", textTransform: "capitalize" }}>
                    {paymethods.filter((i) => i.id === item.payMethod).length >
                      0 &&
                      paymethods.filter((i) => i.id === item.payMethod)[0].name}
                    :
                  </p>
                </Col>
                <Col span={8}>
                  <p>{item.paymentAmt}</p>
                </Col>
              </Row>
            ))}
          <Row gutter={24}>
            <Col span={16}>
              <p style={{ fontSize: "12px" }}>
                {PAYMENT_SCREEN.COLLECTION_POINTS || "Collection Points:"}
              </p>
            </Col>
            <Col span={8}>
              <p>{customer_col_points}</p>
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row gutter={24}>
            <Col span={14}>
              {PAYMENT_SCREEN.TOTAL_WITHOUT_TAX || "Total Without Tax"}
            </Col>
            <Col span={10}>
              {PAYMENT_SCREEN.SAR || "SAR"}{" "}
              {order.totalWithoutTax && order.totalWithoutTax.toFixed(2)}
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={14}>{PAYMENT_SCREEN.TAX || "Tax"}</Col>
            <Col span={10}>
              {PAYMENT_SCREEN.SAR || "SAR"}{" "}
              {order.totalWithoutTax &&
                (actualAmt - order.totalWithoutTax).toFixed(2)}
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={14}>{PAYMENT_SCREEN.TOTAL_AMOUNT || "Total Amount"}</Col>
            <Col span={10}>
              {PAYMENT_SCREEN.SAR || "SAR"} {actualAmt.toFixed(2)}
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={14}>{PAYMENT_SCREEN.PAID || "Paid"}</Col>
            <Col span={10}>
              {PAYMENT_SCREEN.SAR || "SAR"} {order.paidAmt}
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={14}>{PAYMENT_SCREEN.DISCOUNT || "Discount"}</Col>
            <Col span={10}>
              {PAYMENT_SCREEN.SAR || "SAR"} {discountAmt}
            </Col>
          </Row>
          {extraCharge > 0 && (
            <Row gutter={24}>
              <Col span={14}>
                {PAYMENT_SCREEN.EXTRA_CHARGE || "Extra Charge"}
              </Col>
              <Col span={10}>
                {PAYMENT_SCREEN.SAR || "SAR"}{" "}
                {parseFloat(extraCharge).toFixed(2)}
              </Col>
            </Row>
          )}
          <Row gutter={24}>
            <Col span={14}>{PAYMENT_SCREEN.REMAINING || "Remaining:"}</Col>
            <Col span={10}>
              {PAYMENT_SCREEN.SAR || "SAR"}{" "}
              {(
                parseFloat(extraCharge) +
                parseFloat(totalNet) -
                order.paidAmt
              ).toFixed(2)}
            </Col>
          </Row>
          {paymethods.length > 0 &&
            paymethods.map((item) => (
              <Button
                className={`discBtn  ${order.payMethod == item.id &&
                  "selected"}`}
                onClick={() => changePayMethod(item.id)}
                value={item.id}
                key={item.id}
              >
                {item.name}
              </Button>
            ))}
        </Col>
        <Col span={5}>
          {paymethods.filter((item) => item.id == order.payMethod).length > 0 &&
            paymethods
              .filter((item) => item.id == order.payMethod)[0]
              .name.toLowerCase() == "cash" && (
              <>
                <Button
                  className={`selectAmount ${selectAmountbtn == 10 &&
                    "selected"}`}
                  onClick={() => {
                    setAmountPaycheck(10);
                    setSelectAmountbtn(10);
                  }}
                >
                  10
                </Button>
                <Button
                  onClick={() => {
                    setAmountPaycheck(50);
                    setSelectAmountbtn(50);
                  }}
                  className={`selectAmount ${selectAmountbtn == 50 &&
                    "selected"}`}
                >
                  50
                </Button>
                <Button
                  onClick={() => {
                    setAmountPaycheck(100);
                    setSelectAmountbtn(100);
                  }}
                  className={`selectAmount ${selectAmountbtn == 100 &&
                    "selected"}`}
                >
                  100
                </Button>
                <Button
                  onClick={() => {
                    setAmountPaycheck(500);
                    setSelectAmountbtn(500);
                  }}
                  className={`selectAmount ${selectAmountbtn == 500 &&
                    "selected"}`}
                >
                  500
                </Button>
              </>
            )}

          <Button
            className={`selectAmount ${selectAmountbtn == 1 && "selected"}`}
            onClick={() => {
              setAmountPaycheck(
                (
                  parseFloat(extraCharge) +
                  parseFloat(totalNet) -
                  order.paidAmt
                ).toFixed(2),
              );
              setSelectAmountbtn(1);
            }}
          >
            {(
              parseFloat(extraCharge) +
              parseFloat(totalNet) -
              order.paidAmt
            ).toFixed(2)}
          </Button>
          <Button
            className={`selectAmount ${selectAmountbtn == 0 && "selected"}`}
            onClick={() => {
              setCustomModal(true);
              setSelectAmountbtn(0);
            }}
          >
            {PAYMENT_SCREEN.CUSTOM || "Custom"}
          </Button>
        </Col>
      </Row>

      {colModalVisible && (
        <Modal
          title={PAYMENT_SCREEN.LABELS.USE_COLL_POINTS_MODAL_TITLE}
          className="coupon-modal"
          visible={colModalVisible}
          onCancel={() => setColModalVisible(false)}
          onOk={() => {
            colModalOkHandler();
          }}
          footer={false}
        >
          <Form onSubmit={colModalOkHandler}>
            <Form.Item>
              {getFieldDecorator("collectPoints", {
                rules: [
                  {
                    required: true,
                    message: PAYMENT_SCREEN.MESSAGES.COLL_POINTS,
                  },
                ],
              })(
                <InputNumber
                  style={{ width: "100%" }}
                  onChange={(v) => v && setColl_points(v)}
                  placeholder={PAYMENT_SCREEN.PLACEHOLDERS.COLL_POINTS}
                />,
              )}
            </Form.Item>
          </Form>
          <Card>
            <div style={{ width: "100%", height: "70%", margin: "0 auto" }}>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div
                  className="posButton  calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRight: "none",
                  }}
                  onClick={() => calculatorCollectionPoints(1)}
                >
                  1
                </div>
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRight: "none",
                  }}
                  onClick={() => calculatorCollectionPoints(2)}
                >
                  2
                </div>
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => calculatorCollectionPoints(3)}
                >
                  3
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRight: "none",
                    borderTop: "none",
                  }}
                  onClick={() => calculatorCollectionPoints(4)}
                >
                  4
                </div>
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    borderTop: "none",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRight: "none",
                  }}
                  onClick={() => calculatorCollectionPoints(5)}
                >
                  5
                </div>
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    borderTop: "none",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => calculatorCollectionPoints(6)}
                >
                  6
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRight: "none",
                    borderTop: "none",
                  }}
                  onClick={() => calculatorCollectionPoints(7)}
                >
                  7
                </div>
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    borderTop: "none",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRight: "none",
                  }}
                  onClick={() => calculatorCollectionPoints(8)}
                >
                  8
                </div>
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    borderTop: "none",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => calculatorCollectionPoints(9)}
                >
                  9
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRight: "none",
                    borderTop: "none",
                  }}
                  onClick={() => calculatorCollectionPoints("c")}
                >
                  {PAYMENT_SCREEN.CLEAR || "C"}
                </div>
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    borderTop: "none",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRight: "none",
                  }}
                  onClick={() => calculatorCollectionPoints(0)}
                >
                  0
                </div>
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    borderTop: "none",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => calculatorCollectionPoints("b")}
                >
                  {PAYMENT_SCREEN.BACK || "X"}
                </div>
              </div>
            </div>
          </Card>
          <Form.Item>
            <Button
              onClick={colModalOkHandler}
              loading={collectionBtnLoader}
              disabled={
                coll_points <
                  JSON.parse(localStorage.getItem("branch_data")).minPoint ||
                coll_points > customer_col_points
                  ? true
                  : false
              }
              className="signup-form-button btnSpacing"
              htmlType="submit"
              size="large"
              block
            >
              {PAYMENT_SCREEN.SUBMIT || "Submit"}
            </Button>
          </Form.Item>
        </Modal>
      )}
      {customModal && (
        <Modal
          title={PAYMENT_SCREEN.CUSTOM_AMOUNT || "Custom Amount"}
          className="coupon-modal"
          visible={customModal}
          onCancel={() => setCustomModal(false)}
          onOk={() => {
            calculatorFunction("e");
          }}
          footer={false}
        >
          {loading && <Spin className="loading-true" />}
          <div
            style={{
              width: "90%",
              height: "70%",
              margin: "0 auto",
              loading: true ? 0.3 : 1.0,
            }}
          >
            <h2 className="amount_Enter"> {amountPay}</h2>
            <div className="calculator_btn_parent_div">
              <div
                className="posButton  calculatorPayButton"
                style={{
                  border: "1px solid #000",
                  width: "100%",
                  height: "100%",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRight: "none",
                }}
                onClick={() => calculatorFunction(1)}
              >
                1
              </div>
              <div
                className="posButton calculatorPayButton"
                style={{
                  border: "1px solid #000",
                  width: "100%",
                  height: "100%",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRight: "none",
                }}
                onClick={() => calculatorFunction(2)}
              >
                2
              </div>
              <div
                className="posButton calculatorPayButton"
                style={{
                  border: "1px solid #000",
                  width: "100%",
                  height: "100%",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => calculatorFunction(3)}
              >
                3
              </div>
            </div>
            <div className="calculator_btn_parent_div">
              <div
                className="posButton calculatorPayButton"
                style={{
                  border: "1px solid #000",
                  width: "100%",
                  height: "100%",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRight: "none",
                  borderTop: "none",
                }}
                onClick={() => calculatorFunction(4)}
              >
                4
              </div>
              <div
                className="posButton calculatorPayButton"
                style={{
                  border: "1px solid #000",
                  borderTop: "none",
                  width: "100%",
                  height: "100%",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRight: "none",
                }}
                onClick={() => calculatorFunction(5)}
              >
                5
              </div>
              <div
                className="posButton calculatorPayButton"
                style={{
                  border: "1px solid #000",
                  borderTop: "none",
                  width: "100%",
                  height: "100%",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => calculatorFunction(6)}
              >
                6
              </div>
            </div>
            <div className="calculator_btn_parent_div">
              <div
                className="posButton calculatorPayButton"
                style={{
                  border: "1px solid #000",
                  width: "100%",
                  height: "100%",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRight: "none",
                  borderTop: "none",
                }}
                onClick={() => calculatorFunction(7)}
              >
                7
              </div>
              <div
                className="posButton calculatorPayButton"
                style={{
                  border: "1px solid #000",
                  borderTop: "none",
                  width: "100%",
                  height: "100%",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRight: "none",
                }}
                onClick={() => calculatorFunction(8)}
              >
                8
              </div>
              <div
                className="posButton calculatorPayButton"
                style={{
                  border: "1px solid #000",
                  borderTop: "none",
                  width: "100%",
                  height: "100%",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => calculatorFunction(9)}
              >
                9
              </div>
            </div>
            <div className="calculator_btn_parent_div">
              <div
                className="posButton calculatorPayButton"
                style={{
                  border: "1px solid #000",
                  width: "100%",
                  height: "100%",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRight: "none",
                  borderTop: "none",
                }}
                onClick={() => calculatorFunction("c")}
              >
                {PAYMENT_SCREEN.CLEAR || "C"}
              </div>
              <div
                className="posButton calculatorPayButton"
                style={{
                  border: "1px solid #000",
                  borderTop: "none",
                  width: "100%",
                  height: "100%",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRight: "none",
                }}
                onClick={() => calculatorFunction(0)}
              >
                0
              </div>
              <div
                className="posButton calculatorPayButton"
                style={{
                  border: "1px solid #000",
                  borderTop: "none",
                  width: "100%",
                  height: "100%",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => calculatorFunction("b")}
              >
                {PAYMENT_SCREEN.BACK || "X"}
              </div>
            </div>
            <div className="calculator_btn_parent_div">
              <div
                className="posButton calculatorPayButton"
                style={{
                  border: "1px solid #000",
                  width: "100%",
                  flexGrow: 1,
                  flexShrink: 2,
                  height: "100%",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRight: "none",
                  borderTop: "none",
                }}
                onClick={() => calculatorFunction(".")}
              >
                .
              </div>
              <div
                className="posButton calculatorPayButton"
                style={{
                  border: "1px solid #000",
                  width: "100%",
                  flexGrow: 2,
                  height: "100%",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRight: "none",
                  borderTop: "none",
                }}
                onClick={() => calculatorFunction("e")}
              >
                {PAYMENT_SCREEN.BUTTONS.PAY}
              </div>
            </div>
          </div>
        </Modal>
      )}
      {visible && (
        <Modal
          title={PAYMENT_SCREEN.LABELS.USE_COUPON_MODAL_TITLE}
          className="coupon-modal"
          visible={visible}
          onCancel={() => setVisible(false)}
          onOk={() => {
            onOkayHandler();
          }}
          footer={false}
        >
          <Form onSubmit={onOkayHandler}>
            <Form.Item>
              {getFieldDecorator("couponNo", {
                rules: [
                  {
                    required: true,
                    message: PAYMENT_SCREEN.MESSAGES.COUPON_NO,
                  },
                ],
              })(<Input placeholder={PAYMENT_SCREEN.PLACEHOLDERS.COUPON_NO} />)}
            </Form.Item>
            <Form.Item>
              <Button
                loading={couponBtnLoader}
                disabled={order.isMinCharge}
                className="signup-form-button btnSpacing"
                htmlType="submit"
                size="large"
                block
              >
                {PAYMENT_SCREEN.SUBMIT || "Submit"}
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      )}
      {isCashGivenModal && (
        <Modal
          title={PAYMENT_SCREEN.LABELS.USE_CASH_GIVEN_MODAL_TITLE}
          className="coupon-modal"
          visible={isCashGivenModal}
          onCancel={() => {
            setIsCashGivenModal(false);
            document.getElementById("root").classList.remove("blurClass");
          }}
          onOk={() => {
            cashGivenModalHandler();
          }}
          footer={false}
        >
          <h3 className="cal_amount" style={{ textAlign: "center" }}>
            {cashGiven}
          </h3>
          <Card>
            <div style={{ width: "100%", height: "70%", margin: "0 auto" }}>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div
                  className="posButton  calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRight: "none",
                  }}
                  onClick={() => calculatorFunctioncashGiven(1)}
                >
                  1
                </div>
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRight: "none",
                  }}
                  onClick={() => calculatorFunctioncashGiven(2)}
                >
                  2
                </div>
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => calculatorFunctioncashGiven(3)}
                >
                  3
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRight: "none",
                    borderTop: "none",
                  }}
                  onClick={() => calculatorFunctioncashGiven(4)}
                >
                  4
                </div>
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    borderTop: "none",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRight: "none",
                  }}
                  onClick={() => calculatorFunctioncashGiven(5)}
                >
                  5
                </div>
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    borderTop: "none",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => calculatorFunctioncashGiven(6)}
                >
                  6
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRight: "none",
                    borderTop: "none",
                  }}
                  onClick={() => calculatorFunctioncashGiven(7)}
                >
                  7
                </div>
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    borderTop: "none",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRight: "none",
                  }}
                  onClick={() => calculatorFunctioncashGiven(8)}
                >
                  8
                </div>
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    borderTop: "none",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => calculatorFunctioncashGiven(9)}
                >
                  9
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRight: "none",
                    borderTop: "none",
                  }}
                  onClick={() => calculatorFunctioncashGiven("c")}
                >
                  {PAYMENT_SCREEN.CLEAR || "C"}
                </div>
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    borderTop: "none",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRight: "none",
                  }}
                  onClick={() => calculatorFunctioncashGiven(0)}
                >
                  0
                </div>
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    borderTop: "none",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => calculatorFunctioncashGiven("b")}
                >
                  {PAYMENT_SCREEN.BACK || "X"}
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    width: "100%",
                    flexGrow: 1,
                    flexShrink: 2,
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRight: "none",
                    borderTop: "none",
                  }}
                  onClick={() => calculatorFunctioncashGiven(".")}
                >
                  .
                </div>
                <div
                  className="posButton calculatorPayButton"
                  style={{
                    border: "1px solid #000",
                    width: "100%",
                    flexGrow: 2,
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRight: "none",
                    borderTop: "none",
                  }}
                  onClick={cashGivenModalHandler}
                >
                  {PAYMENT_SCREEN.PAY || "PAY"}
                </div>
              </div>
            </div>
          </Card>
          <Form.Item>
            {/* <Button loading={couponBtnLoader}  className="signup-form-button btnSpacing"  onClick={this.cashGivenModalHandler} size="large" block >Pay</Button> */}
          </Form.Item>
        </Modal>
      )}

      <Row
        gutter={24}
        style={{ opacity: loading ? 0.3 : 1.0, display: "none" }}
      >
        <Col span={7}></Col>
        <Col span={8}>
          <Button
            type="primary"
            size="large"
            className="discBtn"
            onClick={() => {
              props.cancelPopUp();
            }}
          >
            {PAYMENT_SCREEN.CANCEL || "Cancel"}
          </Button>
        </Col>
        <Col span={1}></Col>
        <Col span={8}>
          {order.payMethod &&
            (selectAmountbtn == 10 ||
              selectAmountbtn == 50 ||
              selectAmountbtn == 100 ||
              selectAmountbtn == 1 ||
              selectAmountbtn == 500) && (
              <Button
                type="primary"
                size="large"
                className="discBtn"
                loading={loading}
                onClick={() => calculatorFunction("e")}
              >
                {PAYMENT_SCREEN.PAY || "Pay"}
              </Button>
            )}
        </Col>
      </Row>
    </React.Fragment>
  );
}

export default Form.create()(PaymentPopUp);
